export function getUser (state) {
    return state.user
}

export function getToken (state) {
    return state.token
}

export function user (state) {
    return state.user;
}

export function menu (state) {
    return state.menu;
}
    
export function isAuth (state) {
   return state.token !== null;
}

export function getEmpresaDest(state)
{
    return state.empresaDest;
}

export function getErrorLogin (state) {
    return state.errorLogin;
}

export function getTitleScreen (state) {
    return state.titleScreen;
}

export function getShowLoading (state) {
    return state.showLoading;
}

export function getEnum(state)
{
    return tag => {
        // console.log('TAGG',tag);
        // eslint-disable-next-line no-prototype-builtins
        if (state.enums.hasOwnProperty(tag)) {
            return state.enums[tag]
        } else {
            return [{value:'',label:''}]
        }
    }
}


export function getEnumLV(state)
{
    return tag => {
        // console.log('TAGG',tag);
        // eslint-disable-next-line no-prototype-builtins
        if (state.enumsLV.hasOwnProperty(tag)) {
            return state.enumsLV[tag]
        } else {
            return [{value:'',label:''}]
        }
    }
}

export function getEnumObj(state)
{
    return tag => {
        // eslint-disable-next-line no-prototype-builtins
        if (state.enumsObjs.hasOwnProperty(tag)) {
            return state.enumsObjs[tag]
        } else {
            return {value:'',label:''}
        }
    }
}

export function enums(state)
{
    return state.enums;
}

// export  getEnum (state) => (tag) => {
//     if (tag in state.enums) {
//         return state.enums[tag]
//     } else {
//         return [{value:'',label:''}]
//     }
// }

export function readToken (state) {
    return parseJwt(state.token)
}

export function dataExpLogin (state) {
    const token = readToken(state)
    const milliseconds = token.exp * 1000 // milisegundos
    return new Date(milliseconds)
}

export function dataRenovar (state) {
    return addMinutes(dataExpLogin(state), -4)
}
  
function addMinutes (date, minutes) {
    return new Date(date.getTime() + minutes * 60000)
}


function parseJwt (token) {
    if (!token) {
        return {}
    }
    var base64Url = token.split('.')[1]
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))

    return JSON.parse(jsonPayload)
}
  
export function nameApp (state) {
    return state.name;
}

export function companyDeveloper (state) {
    return state.companyDeveloper;
}

export function tokenPainel (state) {
    return state.tokenPainel
}

export function multitenancy (state) {
    return state.multitenancy
}
